var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCriticaCare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.09277,
    y: 1.21094,
    width: 72.8042,
    height: 72.8042,
    rx: 7.5,
    stroke: "#222222",
    strokeDasharray: "2 2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 24.0537C20.1022 24.0537 19.7206 24.2128 19.4393 24.496C19.158 24.7792 19 25.1633 19 25.5637V49.6638C19 50.0643 19.158 50.4483 19.4393 50.7315C19.7206 51.0147 20.1022 51.1738 20.5 51.1738H35.5V54.4083H28.693V57.4283H45.3085V54.4083H38.5V51.1723H53.5C53.8978 51.1723 54.2794 51.0132 54.5607 50.73C54.842 50.4468 55 50.0628 55 49.6623V25.5637C55 25.1633 54.842 24.7792 54.5607 24.496C54.2794 24.2128 53.8978 24.0537 53.5 24.0537H20.5ZM35.3605 28.1217L30.256 37.1592H21.769V40.1597H32.0185L34.447 35.8606L37.2835 45.7483L43.9285 37.2423H50.7235C51.1208 37.2443 51.5027 37.0875 51.7853 36.8064C52.0679 36.5253 52.2282 36.1428 52.231 35.7428C52.2286 35.3426 52.0685 34.9597 51.7858 34.6783C51.5032 34.3968 51.1211 34.2399 50.7235 34.2419H42.454L38.551 39.2401L35.3605 28.1217Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriticaCare);
export default __webpack_public_path__ + "static/media/critica-care.fddac0b685ddfc73375dc10efd7d70aa.svg";
export { ForwardRef as ReactComponent };